class HideOnKlaviyoStep extends HTMLElement {
  constructor() {
    super();

    this.observer = null;
    this.init = this.init.bind(this);
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", this.init, { once: true });
    } else {
      this.init();
    }
  }

  disconnectedCallback() {
    document.removeEventListener("DOMContentLoaded", this.init);
    this.observer?.disconnect();
  }

  init() {
    this.section = this.closest(".shopify-section");
    if (!this.section) return;

    let target = this.section.nextElementSibling;
    while (target && !target.querySelector('[class*="klaviyo-form-"]')) {
      target = target.nextElementSibling;
    }
    if (!target) return;

    this.target = target;
    this.update();
    this.observer = new MutationObserver(this.update);
    this.observer.observe(target, { childList: true, subtree: true });
  }

  update() {
    const form = this.target.querySelector("form.klaviyo-form");
    const pastEmailStep = form && !form.querySelector('input[type="email"]');
    this.section.style.display = pastEmailStep ? "none" : "";
  }
}

customElements.define("hide-on-klaviyo-step", HideOnKlaviyoStep);
